import { render, staticRenderFns } from "./modifyPostcard.vue?vue&type=template&id=0215cf03&scoped=true&"
import script from "./modifyPostcard.vue?vue&type=script&lang=js&"
export * from "./modifyPostcard.vue?vue&type=script&lang=js&"
import style0 from "./modifyPostcard.vue?vue&type=style&index=0&id=0215cf03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215cf03",
  null
  
)

export default component.exports